import { render, staticRenderFns } from "./BtnAdicionarAmigo.vue?vue&type=template&id=50525246&scoped=true&"
import script from "./BtnAdicionarAmigo.vue?vue&type=script&lang=js&"
export * from "./BtnAdicionarAmigo.vue?vue&type=script&lang=js&"
import style0 from "./BtnAdicionarAmigo.vue?vue&type=style&index=0&id=50525246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50525246",
  null
  
)

export default component.exports